/* eslint-disable jsx-a11y/media-has-caption */
import { Button, Col, Modal, Row } from 'antd'
import React, { Dispatch, FC, SetStateAction, useState } from 'react'
import { globalConfirm } from 'components/elements/global'
import { TModalState, TMode } from 'types'
import { useAppDispatch } from 'hooks'
import { baseAPI } from 'api/baseApi'
import TwlImage from '../images/twilio.png'
import { AddNewIntegrationModal } from './AddFbntegrationModal'
import { TIntegrationItem, TwilioData } from '../types'
import { AddTwlIntergrationModal } from './AddTwlIntergrationModal'
import VoiceCallingSection from './VoiceCallingSection'
import { useUnlinkTwilioeMutation } from '../api'

const initModalState: TModalState<TwilioData | null> = {
 mode: 'ADD',
 data: null,
 show: false,
}

const TwlIntergrationModal: FC<{
 show?: boolean
 onCancel?: () => void
 data?: TwilioData
}> = ({ onCancel, show, data }) => {
 const [modalState, setModalState] = useState<TModalState>(initModalState)
 const [unlinkTwilio] = useUnlinkTwilioeMutation()
 const d = useAppDispatch()
 const handleDisconnect = () => {
  globalConfirm({
   content: 'Are you sure you want to disconnect Twilio?',
   onOk: async () => {
    await unlinkTwilio().unwrap()
    d(
     baseAPI.util.invalidateTags([
      'TWL-INT_DTLS',
      'GLOBAL_SETTINGS',
      'GET_MY_PROFILE',
     ]),
    )
   },
  })
 }

 return (
  <Modal footer={null} visible={show} onCancel={onCancel} width="100%">
   <div className="intgr-modal">
    <div className="intgr-modal-top">
     <div className="intgr-modal-lgo">
      <img className="int-card-new-img" src={TwlImage} alt="" />
      <p>
       Seamlessly connect your Twilio account to AgentRoof CRM to send and
       receive SMS directly.
      </p>
     </div>
     <div className="intgr-modal-content">
      <Row style={{ flex: 1 }}>
       <Col flex={1}>
        {data ? (
         <div className="p-4">
          <h2>Twilio Account Details</h2>
          <div
           style={{
            display: 'flex',
            flexDirection: 'column',
            rowGap: '6px',
            alignItems: 'start',
           }}
          >
           <div
            className="px-2 py-1"
            style={{ border: '1px solid #bbb', borderRadius: '7px' }}
           >
            Twilio Phone: <strong>{data.phone_number}</strong>
           </div>
           <div
            className="px-2 py-1"
            style={{ border: '1px solid #bbb', borderRadius: '7px' }}
           >
            Account SID: <strong>{data.twilio_account_id}</strong>
           </div>
           <div className="d-flex mt-2" style={{ columnGap: '5px' }}>
            <Button
             onClick={() => {
              setModalState({ mode: 'EDIT', show: true, data })
             }}
             shape="round"
             type="primary"
            >
             Update Credentials
            </Button>
            <Button onClick={handleDisconnect} shape="round">
             Disconnect
            </Button>
           </div>
           <VoiceCallingSection data={data} />
          </div>
         </div>
        ) : (
         <div className="p-4">
          <h2>Configure Twilio Account</h2>
          <ol className="ps-4">
           <li>Login to your Twilio Dashboard</li>
           <li>Copy your Account SID, Auth Token and Phone Number</li>
           <li>Paste the details </li>
          </ol>
          <Button
           onClick={() => {
            setModalState({ mode: 'ADD', show: true })
           }}
           shape="round"
           type="primary"
          >
           Connect Twilio
          </Button>
         </div>
        )}
       </Col>
       <div className="intgr-modal-video">
        <video controls>
         <source
          src="https://cdn.agentroof.com/crm-tutorial/twilio-integration.mp4"
          type="video/mp4"
         />
         Your browser does not support the video tag.
        </video>
       </div>
      </Row>
     </div>
    </div>
    <hr className="mt-4" style={{ border: '2px solid #aaa', width: '100%' }} />
    <div className="intgr-modal-bottom">
     <p>
      Enhance your lead engagement by integrating your CRM with Twilio. With
      this powerful integration, you can send and receive SMS directly from
      AgentRoof CRM, ensuring faster responses, better follow-ups, and more
      meaningful conversations with your leads.
     </p>
     <h4>Key Features:</h4>
     <ul>
      <li>
       <strong>Two-Way Messaging:</strong> Instantly send and receive SMS within
       the CRM, keeping all lead conversations in one central place.
      </li>
      <li>
       <strong>Automatic Lead Linking: </strong> All SMS interactions are
       automatically tied to the corresponding lead profile, giving you a
       complete communication history.
      </li>
      <li>
       <strong>Actionable Insights:</strong> Use the campaign name as a source
       to trigger automated workflows, such as Action Plans, Listing Alerts, and
       other tasks, ensuring timely and effective engagement with your leads.
      </li>
      <li>
       <strong>Custom Sender IDs:</strong> Use your Twilio numbers to
       personalize your outreach and build trust with leads.
      </li>
      <li>
       <strong>SMS Automation:</strong> Trigger automated SMS campaigns,
       reminders, and alerts based on lead activity, saving you time while
       staying highly responsive.
      </li>
      <li>
       <strong>Conversation Tracking: </strong> View full conversation threads
       in the CRM, making it easy for your team to collaborate and maintain
       consistent communication.
      </li>
      <li>
       <strong>Scalable Messaging: </strong> Whether you’re handling a few leads
       or thousands, Twilio integration ensures reliable, secure, and scalable
       SMS delivery.
      </li>
     </ul>
     <h4>Why Use Twilio Integration?</h4>
     <p>
      This integration helps you stay connected with leads in real-time,
      ensuring you never miss an opportunity. By managing SMS conversations
      directly in the CRM, you streamline communication, improve response times,
      and build stronger relationships with prospects. Integrating Twilio with
      your CRM is the perfect way to modernize your lead communication strategy,
      making every interaction timely, personal, and impactful.
     </p>
    </div>
   </div>
   <AddTwlIntergrationModal
    editData={modalState.data}
    OnCancel={() => {
     setModalState(initModalState)
    }}
    mode={modalState.mode}
    show={modalState.show}
   />
   {/* {showIntegrationModal && (
    <AddNewIntegrationModal
     show={showIntegrationModal}
     intItems={intItems}
     setIntItems={setIntItems}
     OnCancel={() => {
      setShowIntegrationModal(false)
     }}
    />
   )} */}
  </Modal>
 )
}

export default TwlIntergrationModal
